module.exports = __webpack_public_path__ + "img/3-5.0b6d761c.svg";